module.exports = __webpack_public_path__ + "assets/img/station9.b93fdfe4.png";